export default __webpack_public_path__ + "static/media/Canach Scales.5c449cee.jpg";